import { render, staticRenderFns } from "./AkPercentage.vue?vue&type=template&id=39da0472&"
import script from "./AkPercentage.vue?vue&type=script&lang=js&"
export * from "./AkPercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/ijsedal/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39da0472')) {
      api.createRecord('39da0472', component.options)
    } else {
      api.reload('39da0472', component.options)
    }
    module.hot.accept("./AkPercentage.vue?vue&type=template&id=39da0472&", function () {
      api.rerender('39da0472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/AkPercentage.vue"
export default component.exports